export const CREATEINFO = {subtitle: "イベント企画　広告提案",
                           description: "エンジニア含む若いメンバーのみで創設した弊社で企業様とタイアップ、または依頼を受け、お客様のニーズに合ったイベントや広告を若い世代の観点から他社とは異なった運営、代行します。"}

export const SPREADINFO = {subtitle: "インフルエンサー紹介",
                           description: "若い世代の次期インフルエンサーを抱えているため、より注目度が上がり集客に役立たせます"}

export const PROGRESSINFO = {subtitle: "各種運用　継続的コンサルティング",
                            description: "コンテンツに終わりはありません。効果的な運用を提案します。例えばお客様のSNSを弊社で運用しカスタマーとの繋がりを保ちます。"}